import { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  useActiveUsers,
  useConnectionTrends,
  useTopUsers,
  useActionsBreakdown,
  useModuleUsage,
  useAiUsagePerUser,
} from '../hooks/useAnalytics';
import { ActiveUsersCards } from '../components/ActiveUsersCards';
import { ConnectionTrendsChart } from '../components/ConnectionTrendsChart';
import { TopUsersTable } from '../components/TopUsersTable';
import { ActionsBreakdownChart } from '../components/ActionsBreakdownChart';
import { ModuleUsageChart } from '../components/ModuleUsageChart';
import { AiUsageTable } from '../components/AiUsageTable';

const PERIOD_OPTIONS = [
  { value: '7', label: '7 derniers jours' },
  { value: '30', label: '30 derniers jours' },
  { value: '90', label: '90 derniers jours' },
];

export function AnalyticsPage() {
  const [days, setDays] = useState(30);

  const activeUsers = useActiveUsers();
  const connectionTrends = useConnectionTrends(days);
  const topUsers = useTopUsers(days, 10);
  const actionsBreakdown = useActionsBreakdown(days);
  const moduleUsage = useModuleUsage(days);
  const aiUsagePerUser = useAiUsagePerUser(days);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Statistiques</h1>
          <p className="text-muted-foreground">
            Vue d'ensemble de l'activit&eacute; des utilisateurs
          </p>
        </div>
        <Select value={String(days)} onValueChange={(v) => setDays(Number(v))}>
          <SelectTrigger className="w-[200px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PERIOD_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Active users cards */}
      <ActiveUsersCards data={activeUsers.data} isLoading={activeUsers.isLoading} />

      {/* Connection trends */}
      <ConnectionTrendsChart data={connectionTrends.data} isLoading={connectionTrends.isLoading} />

      {/* Charts row: Actions breakdown + Module usage */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ActionsBreakdownChart data={actionsBreakdown.data} isLoading={actionsBreakdown.isLoading} />
        <ModuleUsageChart data={moduleUsage.data} isLoading={moduleUsage.isLoading} />
      </div>

      {/* Top users */}
      <TopUsersTable data={topUsers.data} isLoading={topUsers.isLoading} />

      {/* AI Usage */}
      <AiUsageTable data={aiUsagePerUser.data} isLoading={aiUsagePerUser.isLoading} />
    </div>
  );
}
